export default [
  {
    name: 'getMobileVersion',
    method: 'GET',
    path: '/vue/system/mobileversion-get'
  },
  {
    name: 'getMobileVersionPage',
    method: 'POST',
    path: '/vue/system/mobileversion-page'
  },
  {
    name: 'saveMobileVersion',
    method: 'POST',
    path: '/vue/system/mobileversion-save'
  },
  {
    name: 'deleteMobileVersion',
    method: 'POST',
    path: '/vue/system/mobileversion-delete'
  }
];
